export var GetSpreedlyCredentialsResponseType;
(function (GetSpreedlyCredentialsResponseType) {
    GetSpreedlyCredentialsResponseType["Success"] = "Success";
    GetSpreedlyCredentialsResponseType["Failure"] = "Failure";
})(GetSpreedlyCredentialsResponseType || (GetSpreedlyCredentialsResponseType = {}));
//# sourceMappingURL=payments.js.map